import { Divider, Input, Switch } from 'antd';
import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { FormItem, TabPageContentWrapper } from 'src/components/SharedDetailsComponents';
import { useGlobal } from 'src/contexts/GlobalContext';
import SettingCard from 'src/pages/Devices/DeviceDetails/TabPages/SensorSettings/components/SettingCard';

import { useCampaignDetails } from '../../CampaignDetailsContext';
import { StyledInput } from '../Settings/Settings.styled';
import { HeaderWrapper } from './Design.styled';

export const Design = () => {
  const { isDesktop } = useGlobal();
  const { formMethods, campaign } = useCampaignDetails();
  const { watch } = formMethods;
  const introductionEnabled = watch('content.introduction.enabled');
  const { t } = useTranslation();

  return (
    <>
      <SettingCard
        title={t('campaigns.design.title')}
        description={t('campaigns.design.description')}
        items={[
          {
            header: (
              <HeaderWrapper>
                {t('campaigns.design.landingPage')}
                <Controller
                  name="content.introduction.enabled"
                  control={formMethods.control}
                  render={({ field }) => (
                    <Switch
                      {...field}
                      defaultChecked={!!campaign?.content?.introduction?.enabled}
                      data-testid="campaign-landing-page-enabled-switch"
                    />
                  )}
                />
              </HeaderWrapper>
            ),
            isContentHidden: !introductionEnabled,
            content: (
              <TabPageContentWrapper $isDesktop={false} data-testid="campaign-landing-page-form">
                <FormItem
                  $isDesktop={false}
                  label={t('campaigns.design.landingPageHtml')}
                  name="content.introduction.marketingInfo"
                >
                  <Controller
                    name="content.introduction.marketingInfo"
                    control={formMethods.control}
                    render={({ field }) => (
                      <Input.TextArea
                        {...field}
                        name="content.introduction.marketingInfo"
                        placeholder={t('campaigns.design.landingPageHtmlPlaceholder')}
                        data-testid="campaign-landing-page-html-input"
                      />
                    )}
                  />
                </FormItem>
              </TabPageContentWrapper>
            ),
          },
        ]}
      />
      {isDesktop && <Divider />}
      <SettingCard
        title={t('campaigns.design.resultsPage')}
        description={t('campaigns.design.resultsPageDescription')}
        items={[
          {
            content: (
              <TabPageContentWrapper $isDesktop={isDesktop} data-testid="campaign-results-page-form">
                <FormItem
                  $isDesktop={false}
                  label={t('campaigns.design.resultsPageHtml')}
                  name="content.registration.confirmation"
                >
                  <Controller
                    name="content.registration.confirmation"
                    control={formMethods.control}
                    render={({ field }) => (
                      <Input.TextArea
                        {...field}
                        name="content.registration.confirmation"
                        placeholder={t('campaigns.design.resultsPageHtmlPlaceholder')}
                        data-testid="campaign-results-page-confirmation-input"
                      />
                    )}
                  />
                </FormItem>
                <FormItem
                  $isDesktop={isDesktop}
                  label={t('campaigns.design.callToActionButtonText')}
                  name="content.registration.callToActionButtonTitle"
                >
                  <Controller
                    name="content.registration.callToActionButtonTitle"
                    control={formMethods.control}
                    render={({ field }) => (
                      <StyledInput
                        {...field}
                        name="content.registration.callToActionButtonTitle"
                        placeholder={t('campaigns.design.callToActionButtonTextPlaceholder')}
                        data-testid="campaign-results-page-call-to-action-button-title-input"
                      />
                    )}
                  />
                </FormItem>
                <FormItem
                  $isDesktop={isDesktop}
                  label={t('campaigns.design.callToActionButtonLink')}
                  name="content.registration.callToActionButtonLink"
                >
                  <Controller
                    name="content.registration.callToActionButtonLink"
                    control={formMethods.control}
                    render={({ field }) => (
                      <StyledInput
                        {...field}
                        name="content.registration.callToActionButtonLink"
                        placeholder={t('campaigns.design.callToActionButtonLinkPlaceholder')}
                        data-testid="campaign-results-page-call-to-action-button-link-input"
                      />
                    )}
                  />
                </FormItem>
              </TabPageContentWrapper>
            ),
          },
        ]}
      />
      {isDesktop && <Divider />}
      <SettingCard
        title={t('campaigns.design.photoUpload.title')}
        description={t('campaigns.design.photoUpload.description')}
        items={[
          {
            content: (
              <TabPageContentWrapper $isDesktop={isDesktop} data-testid="campaign-upload-photo-page-form">
                <FormItem
                  $isDesktop={false}
                  label={t('campaigns.design.photoUpload.instructions')}
                  name="content.photoUpload.instructions"
                >
                  <Controller
                    name="content.photoUpload.instructions"
                    control={formMethods.control}
                    render={({ field }) => (
                      <Input.TextArea
                        {...field}
                        name="content.photoUpload.instructions"
                        placeholder={t('campaigns.design.photoUpload.instructionsPlaceholder')}
                        data-testid="campaign-upload-photo-page-instructions-input"
                      />
                    )}
                  />
                </FormItem>
                <FormItem
                  $isDesktop={false}
                  label={t('campaigns.design.photoUpload.success')}
                  name="content.photoUpload.success"
                >
                  <Controller
                    name="content.photoUpload.success"
                    control={formMethods.control}
                    render={({ field }) => (
                      <StyledInput
                        {...field}
                        name="content.photoUpload.success"
                        placeholder={t('campaigns.design.photoUpload.successPlaceholder')}
                        data-testid="campaign-upload-photo-page-success-input"
                      />
                    )}
                  />
                </FormItem>
              </TabPageContentWrapper>
            ),
          },
        ]}
      />
    </>
  );
};
